import React, { ComponentProps, FunctionComponent } from "react";

const CircleStarIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22 22",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M11 0C8.0829 0 5.28509 1.15898 3.222 3.222C1.15901 5.28499 0 8.0829 0 11C0 13.9171 1.15898 16.7149 3.222 18.778C5.28499 20.841 8.0829 22 11 22C13.9171 22 16.7149 20.841 18.778 18.778C20.841 16.715 22 13.9171 22 11C21.996 8.08392 20.835 5.28816 18.7731 3.22712C16.7121 1.16513 13.9161 0.00409596 11.0003 0.00025598L11 0ZM11 20.7999C8.4011 20.7999 5.90793 19.7679 4.07012 17.9299C2.23213 16.0919 1.20012 13.5989 1.20012 11C1.20012 8.4011 2.2321 5.90793 4.07012 4.07012C5.90811 2.23213 8.4011 1.20012 11 1.20012C13.5989 1.20012 16.0921 2.2321 17.9299 4.07012C19.7679 5.90811 20.7999 8.4011 20.7999 11C20.7959 13.5979 19.7619 16.088 17.925 17.925C16.0882 19.7621 13.5981 20.796 11 20.7999Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M16.6002 7.6L13.6002 7.168L12.2562 4.44801C12.0202 3.96902 11.5332 3.66602 11.0002 3.66602C10.4672 3.66602 9.98022 3.96902 9.74424 4.44801L8.40025 7.168L5.4002 7.6C4.8742 7.67899 4.43821 8.04699 4.27222 8.552C4.09722 9.05499 4.22422 9.61399 4.60021 9.99199L6.77619 12.104L6.2642 15.0961C6.1692 15.6201 6.3842 16.1521 6.81618 16.4641C7.25017 16.7751 7.82318 16.8151 8.29616 16.5681L11 15.1601L13.6801 16.6001C13.8821 16.7071 14.1071 16.7621 14.3361 16.7601C14.6231 16.7551 14.902 16.6631 15.1361 16.4961C15.5681 16.1841 15.783 15.6521 15.688 15.1281L15.176 12.136L17.4 9.99201C17.784 9.62002 17.921 9.06002 17.752 8.55202C17.582 8.04002 17.1352 7.67101 16.6002 7.6ZM16.5362 9.128L14.1363 11.464C13.9983 11.606 13.9363 11.805 13.9683 12L14.5283 15.296C14.5463 15.371 14.5143 15.448 14.4483 15.488C14.3873 15.536 14.3013 15.536 14.2403 15.488L11.2804 13.936C11.1064 13.841 10.8944 13.841 10.7204 13.936L7.80048 15.504C7.73948 15.552 7.65348 15.552 7.59248 15.504C7.52648 15.464 7.49448 15.387 7.51248 15.312L8.07248 12.016C8.10448 11.821 8.04248 11.622 7.90448 11.48L5.50449 9.144C5.41849 9.11 5.3735 9.016 5.4005 8.928C5.4225 8.855 5.48449 8.802 5.56049 8.792L8.8726 8.312C9.0666 8.282 9.23361 8.16001 9.3206 7.98402L10.8086 4.97604C10.9046 4.78404 11.0646 4.78404 11.1606 4.97604L12.6486 7.98402C12.7356 8.16002 12.9026 8.28203 13.0966 8.312L16.4087 8.792C16.4847 8.802 16.5467 8.855 16.5687 8.928C16.6017 8.995 16.5887 9.075 16.5367 9.128H16.5362Z",
    })
  );
};

const ForwardRef = React.forwardRef(CircleStarIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
